import { IOrganization } from '@/types/IOrganization';
import IResource from '@/types/IResource';
import { useForm } from 'react-hook-form';

interface IArgs {
	readonly resource: IResource;
	readonly organizations: Array<IOrganization>;
}

export function useCollaboratorsController(args: IArgs) {
	const collaborators =
		args.resource.collaborators?.map((c) => args.organizations.find((o) => o.id === c.organizationId)!) ?? [];

	const form = useForm({ defaultValues: { collaborators } });

	return {
		options: args.organizations,
		form,
	};
}
